import { Box, Flex } from "@chakra-ui/react";
import { useState } from "react";
import Header from "../components/header/header";
import { ClubManagementMenuItem } from "../components/club-management/constants";
import ClubManagementStatistics from "../components/club-management/club-management-statistics";
import ClubManagementBookings from "../components/club-management/club-management-bookings";
import ClubManagementMenu from "../components/club-management/club-management-menu";
import ClubManagementReceipts from "../components/club-management/club-management-receipts";
import ClubManagementUnpaidHours from "../components/club-management/club-management-unpaid-hours";
import ClubManagementUserBookings from "../components/club-management/club-management-user-bookings";
import ClubManagementUsers from "../components/club-management/club-management-users";

const ClubManagementPage = () => {
  const [activeSection, setActiveSection] = useState<ClubManagementMenuItem>();

  return (
    <Box flexDirection="column">
      <Header />

      <Flex h="calc(100vh - 72px)">
        <ClubManagementMenu onSelect={item => setActiveSection(item)} />

        {/* Main content */}
        <Box flex="1" p={6} overflow="auto">
          {activeSection === ClubManagementMenuItem.STATISTICS && <ClubManagementStatistics />}
          {activeSection === ClubManagementMenuItem.USERS && <ClubManagementUsers />}
          {activeSection === ClubManagementMenuItem.BOOKINGS && <ClubManagementBookings />}
          {activeSection === ClubManagementMenuItem.RECEIPTS && <ClubManagementReceipts />}
          {activeSection === ClubManagementMenuItem.USER_BOOKINGS && <ClubManagementUserBookings />}
          {activeSection === ClubManagementMenuItem.UNPAID_HOURS && <ClubManagementUnpaidHours />}
        </Box>
      </Flex>
    </Box>
  );
};

export default ClubManagementPage;
